var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 0H2.6A2.608 2.608 0 000 2.6v20.8A2.608 2.608 0 002.6 26h20.8a2.608 2.608 0 002.6-2.6V2.6A2.608 2.608 0 0023.4 0zM7.8 22.1H3.9V10.4h3.9zM5.85 8.19a2.34 2.34 0 112.34-2.34 2.33 2.33 0 01-2.34 2.34zM22.1 22.1h-3.9v-6.89a1.95 1.95 0 00-3.9 0v6.89h-3.9V10.4h3.9v1.56a4.2 4.2 0 013.25-1.82 4.606 4.606 0 014.55 4.55z",
    fill: "#202124",
    opacity: 0.2
  })));
}

export default SvgLinkedinIconWhite;